<div class="header-content">
  <a href="/">
    <img class="header-logo" src="assets/images/Vaylens-Logo-2.png" />
    <img class="header-small" src="assets/images/Vaylens-Logo.png" />
  </a>
  <div class="divider"></div>
  <h1 class="header-text">
    {{ "HEADER.HOME_CHARGER_ONBOARDING" | translate }}
  </h1>
  <div class="help-button-wrapper">
    <a href="{{ environment.helpUrl }}" target="_blank">
      <button
        [color]="ButtonColor.SECONDARY"
        [leftIcon]="'ic-help'"
        class="d-none d-md-block"
        hcButton
      >
        {{ "COMMON.HELP" | translate }}
      </button>
      <button
        [color]="ButtonColor.SECONDARY"
        [iconButton]="true"
        [leftIcon]="'ic-help'"
        class="d-sm-block d-md-none"
        hcButton
      ></button>
    </a>
  </div>
</div>
